define("auth/routes/o-auth", ["exports", "@ember/routing/route", "later/utils/fetch"], function (_exports, _route, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  class OAuthRoute extends _route.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "queryParams", {
        redirect: {},
        // Redirect address
        authenticity_token: {},
        client_id: {},
        redirect_uri: {},
        state: {},
        response_type: {},
        scope: {},
        code_challenge: {},
        code_challenge_method: {},
        referer: {},
        error: {},
        error_description: {}
      });
    }

    setupController(controller, model) {
      super.setupController(controller, model);
      controller.setProperties({
        payload: model.params,
        appDetails: model.oauthApp
      });
    }

    async model(params) {
      let oauthApp = {};
      const {
        client_id
      } = params;

      if (client_id) {
        const applicationDetailsUrl = "/api/v2/oauth_applications/".concat(client_id);

        try {
          oauthApp = await (0, _fetch.fetch)(applicationDetailsUrl, {
            method: 'get'
          });
        } catch (error) {
          // TODO: add proper error handling should fetching details fail
          console.error('Error coccured fetching SSO app details');
          console.error(error);
        }
      }

      return {
        oauthApp,
        params
      };
    }

  }

  _exports.default = OAuthRoute;
});